/**
 * ESDM Curriculum Checklist domain catalog.
 *
 * Generated alongside esdm-items.ts — see that file's header.
 */

import type { EsdmDomainCode, EsdmItem } from '../types/esdm';
import { ESDM_ITEMS } from './esdm-items';

export interface EsdmDomain {
  code: EsdmDomainCode;
  name: string;
}

export const ESDM_DOMAINS: EsdmDomain[] = [
  { code: 'CR', name: 'Comunicação Receptiva' },
  { code: 'CE', name: 'Comunicação Expressiva' },
  { code: 'CAC', name: 'Atenção Conjunta' },
  { code: 'CS', name: 'Competências Sociais' },
  { code: 'IM', name: 'Imitação' },
  { code: 'CO', name: 'Cognição' },
  { code: 'JO', name: 'Jogo' },
  { code: 'MF', name: 'Motricidade Fina' },
  { code: 'MG', name: 'Motricidade Grossa' },
  { code: 'CT', name: 'Comportamento' },
  { code: 'IP', name: 'Independência Pessoal' },
  { code: 'IPA', name: 'Independência Pessoal: Alimentação' },
  { code: 'IPV', name: 'Independência Pessoal: Vestir' },
  { code: 'IPH', name: 'Independência Pessoal: Higiene' },
  { code: 'IPT', name: 'Independência Pessoal: Tarefas' },
];

export const ESDM_LEVEL_AGE_BANDS: Record<EsdmItem['level'], string> = {
  1: '12 a 18 meses',
  2: '18 a 24 meses',
  3: '24 a 36 meses',
  4: '36 a 48 meses',
};

export function getDomainsForLevel(level: EsdmItem['level']): EsdmDomain[] {
  const codes = new Set(ESDM_ITEMS.filter((item) => item.level === level).map((item) => item.domain));
  return ESDM_DOMAINS.filter((domain) => codes.has(domain.code));
}
